import { useQuery } from '@tanstack/react-query'
import apiClient from '@/api/client'
import type { ListAuditLogsRequest, ListAuditLogsResponse } from '@/types'

const auditApi = {
  list: async (params?: ListAuditLogsRequest): Promise<ListAuditLogsResponse> => {
    const response = await apiClient.get<ListAuditLogsResponse>('/audit/logs', { params })
    return response.data
  },
}

export function useAuditLogs(params?: ListAuditLogsRequest) {
  return useQuery({
    queryKey: ['audit-logs', params],
    queryFn: () => auditApi.list(params),
  })
}
